/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days`)
};

const es_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} días`)
};

const de_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage`)
};

const nl_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dagen`)
};

const fr_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours`)
};

const it_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} giorni`)
};

const pt_br2_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias`)
};

const pt_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias`)
};

const ja_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 日`)
};

const zh_dd_days_count = /** @type {(inputs: { days: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 天`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ days: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_days_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_days_count(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_days_count", locale)
	if (locale === "en") return en_dd_days_count(inputs)
	if (locale === "es") return es_dd_days_count(inputs)
	if (locale === "de") return de_dd_days_count(inputs)
	if (locale === "nl") return nl_dd_days_count(inputs)
	if (locale === "fr") return fr_dd_days_count(inputs)
	if (locale === "it") return it_dd_days_count(inputs)
	if (locale === "pt-BR") return pt_br2_dd_days_count(inputs)
	if (locale === "pt") return pt_dd_days_count(inputs)
	if (locale === "ja") return ja_dd_days_count(inputs)
	return zh_dd_days_count(inputs)
};